<template>
  <v-content>
    <v-container fluid>
      <v-card elevation="5">
        <v-toolbar dense dark color="deep-orange">
          <v-toolbar-title>
            Usuarios disponibles
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            text
            small
            :loading="exportando"
            :disabled="cargando"
            @click="exportar"
          >
            <v-icon left>mdi-file-excel</v-icon>
            Exportar Excel
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row align="center">
            <v-col cols="12" sm="7" md="5">
              <v-text-field
                v-model="busqueda"
                label="Buscar promotor"
                prepend-inner-icon="mdi-magnify"
                clearable
                outlined
                dense
                hide-details
                @keyup.enter="buscar"
                @click:clear="limpiar"
              />
            </v-col>

            <v-col cols="12" sm="5" md="3">
              <v-btn
                color="deep-orange"
                dark
                :loading="cargando"
                @click="buscar"
              >
                Buscar
              </v-btn>
            </v-col>
          </v-row>

          <v-alert
            v-if="error"
            type="error"
            dense
            dismissible
            class="mt-3"
            @input="error = ''"
          >
            {{ error }}
          </v-alert>

          <p class="mt-4 mb-2">
            <strong>{{ total }}</strong>
            promotores disponibles
          </p>

          <v-data-table
            :headers="columnas"
            :items="usuarios"
            :loading="cargando"
            :items-per-page="50"
            hide-default-footer
            no-data-text="No se encontraron usuarios disponibles"
            loading-text="Consultando usuarios..."
          />

          <div
            class="d-flex justify-center align-center mt-4"
          >
            <v-pagination
              v-model="pagina"
              :length="totalPaginas"
              :total-visible="7"
              :disabled="cargando"
              @input="consultar"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import {
  consultarUsuariosDisponibles,
  exportarUsuariosDisponibles,
} from "@/utils/usuariosDisponiblesApi";

export default {
  name: "UsuariosDisponibles",

  data() {
    return {
      busqueda: "",
      filtro: "",
      pagina: 1,
      limite: 50,
      total: 0,
      usuarios: [],
      cargando: false,
      exportando: false,
      error: "",
      columnas: [
        {
          text: "Nombre de usuario",
          value: "username",
          sortable: false,
        },
      ],
    };
  },

  computed: {
    totalPaginas() {
      return Math.max(
        1,
        Math.ceil(this.total / this.limite)
      );
    },
  },

  mounted() {
    this.consultar();
  },

  methods: {
    buscar() {
      this.filtro = (this.busqueda || "").trim();
      this.pagina = 1;
      this.consultar();
    },

    limpiar() {
      this.busqueda = "";
      this.buscar();
    },

    async consultar() {
      this.cargando = true;
      this.error = "";

      try {
        const resultado =
          await consultarUsuariosDisponibles(
            this.$session,
            {
              username: this.filtro,
              pagina: this.pagina,
              limite: this.limite,
            }
          );

        this.total = resultado.total || 0;
        this.usuarios = (resultado.usuarios || [])
          .map((username) => ({ username }));
      } catch (err) {
        this.error =
          err.message || "No fue posible consultar";
        this.total = 0;
        this.usuarios = [];
      } finally {
        this.cargando = false;
      }
    },

    async exportar() {
      this.exportando = true;
      this.error = "";

      try {
        await exportarUsuariosDisponibles(
          this.$session,
          this.filtro
        );
      } catch (err) {
        this.error =
          err.message || "No fue posible exportar";
      } finally {
        this.exportando = false;
      }
    },
  },
};
</script>
